module.exports = __webpack_public_path__ + "static/img/active.fc9c2d0c.svg";